import React from 'react';
import _ from 'underscore';

/**
 * This file was copied from the default option renderer in react-virtualized-select,
 * but it was modified to check for equality by option values, not by option references.
 * This fixes issues with styling focused and selected options.
 * @param props
 * @returns {React.DetailedReactHTMLElement<React.HTMLAttributes<T>, HTMLElement>}
 */
const virtualizedSelectOptionRenderer = ({
  focusedOption,
  focusOption,
  key,
  labelKey,
  option,
  selectValue,
  style,
  valueArray,
}) => {
  let className = ['VirtualizedSelectOption'];

  if (option && focusedOption && _.isEqual(focusedOption, option)) {
    className.push('VirtualizedSelectFocusedOption');
  }

  if (option.disabled) {
    className.push('VirtualizedSelectDisabledOption');
  }

  if (
    valueArray &&
    option &&
    valueArray.findIndex((valueArrayOption) =>
      _.isEqual(valueArrayOption, option)
    ) >= 0
  ) {
    className.push('VirtualizedSelectSelectedOption');
  }

  if (option.className) {
    className.push(option.className);
  }

  const events = option.disabled
    ? {}
    : {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        },
      };

  return React.createElement(
    'div',
    _.extend(
      {
        className: className.join(' '),
        key: key,
        style: style,
        title: option.title,
      },
      events
    ),
    option[labelKey]
  );
};

export { virtualizedSelectOptionRenderer };
